import Xhr from '@Core/xhr'
import clone from 'lodash/cloneDeep'

const allowedMutations = [
  'user/setUser',
  'cart/shipping/option',
  'cart/shipping/locationId',
  'cart/shipping/useAlt',
  'cart/shipping/altShipping',
  'cart/payment/option'
]

const storeState = (state) => {
  let isGuest = state.user.user.id > 1000000000
  let guestId = isGuest ? state.user.user.id : null
  let paymentType = state.cart.payment.option
  let delivery = {
    type: state.cart.shipping.option,
    locationId: state.cart.shipping.locationId,
    alternative: state.cart.shipping.useAlt,
    altAddress: state.cart.shipping.useAlt ? state.cart.shipping.altShipping : null
  }

  let checkoutState = clone({
    isGuest,
    guestId,
    delivery,
    paymentType
  })

  new Xhr(checkoutState).post('/checkout/state')
}

export default (store) => {
  store.subscribe(
    (mutation, state) => {
      if (allowedMutations.indexOf(mutation.type) > -1) {
        setTimeout(() => storeState(state), 100)
      }
      if (mutation.type === 'cart/payment/option' && state.cart.payment.option === 0) {
        setTimeout(() => storeState(state), 2500)
      }
    }
  )
}
